module.exports = __webpack_public_path__ + "static/media/25588050_1703515129723671_5662002094222651491_o.460366e7.jpg";